<template>
	<div v-if="pending" class="text-center" style="transition: none !important;">
		<b-spinner />
	</div>

	<main v-else>
		<header class="justify-between align-items-stretch mb-3" style="transition: none !important;">
			<b-breadcrumb :items="breadcrumb" class="flex-grow-1 mb-0" />

			<b-dropdown
				v-if="$gate.allow('create', 'element') || $gate.allow('create', 'wall') || $gate.allow('delete', item)"
				:id="'room_actions_dropdown_' + roomId"
				:title="$t('Actions')"
				class="ml-3"
				no-caret
				right
			>
				<template slot="button-content">
					<fa fixed-width icon="ellipsis-v" />
				</template>

				<!--        <b-dropdown-item-button-->
				<!--            v-if="$gate.allow('create', 'element')"-->
				<!--            v-b-modal.newElementModal-->
				<!--        >-->
				<!--          <fa fixed-width icon="plus" />-->
				<!--          {{ $t('Create new element') }}-->
				<!--        </b-dropdown-item-button>-->

				<b-dropdown-item-button
					v-if="$gate.allow('create', 'project_foundation')"
					@click="showNewElementModal = true"
				>
					<fa fixed-width icon="plus" />
					{{ $t('Create new element') }}
				</b-dropdown-item-button>

				<b-dropdown-item-button
					v-if="$gate.allow('create', 'project_foundation')"
					@click="showNewFoundationModal = true"
				>
					<fa fixed-width icon="plus" />
					{{ $t('Create new foundation') }}
				</b-dropdown-item-button>

				<b-dropdown-item-button
					v-if="$gate.allow('update', item)"
					v-b-modal.servicesCopyModal
				>
					<fa fixed-width icon="copy" />
					{{ $t('Copy services') }}
				</b-dropdown-item-button>

				<b-dropdown-item-button
					v-if="$gate.allow('create', 'wall')"
					v-b-modal.duplicate-modal
					:disabled="item.busy"
				>
					<fa fixed-width icon="copy" />
					{{ $t('Duplicate') }}
				</b-dropdown-item-button>

				<b-dropdown-item
					v-if="$gate.allow('delete', item)"
					variant="danger"
					@click="handleDelete"
				>
					<fa fixed-width icon="trash" />
					{{ $t('Delete') }}
				</b-dropdown-item>
			</b-dropdown>
		</header>

		<duplicate-modal
			v-if="$gate.allow('create', 'wall')"
			id="duplicate-modal"
			:api-url="duplicateUrl"
			:project-id="projectId"
			@duplicated="handleDuplicated"
		/>

		<services-copy
			v-if="$gate.allow('update', item)"
			:project-id="projectId"
			:wall-id="id"
			:wall-name="item.name"
		/>
		<!--    <b-modal-->
		<!--        v-if="$gate.allow('create', 'element')"-->
		<!--        id="newElementModal"-->
		<!--        :title="$t('New Element')"-->
		<!--        hide-footer-->
		<!--        no-close-on-backdrop-->
		<!--        size="xl"-->
		<!--    >-->
		<!--      <element-form :project-id="projectId" />-->
		<!--    </b-modal>-->

		<project-elements-create-view
			v-if="$gate.allow('create', 'element')"
			:on-close="() => {}"
			:project-id="projectId"
			:visible.sync="showNewElementModal"
		/>
		<project-foundations-create-view
			v-if="$gate.allow('create', 'project_foundation')"
			:on-close="() => {}"
			:project-id="projectId"
			:visible.sync="showNewFoundationModal"
		/>


		<article class="mt-3">
			<b-tabs v-model="tabIndex" content-class="mt-3" @input="handleTabIndex">
				<b-tab :title="$t('Overview')">
					<b-form
						@keydown="item.onKeydown($event)"
						@submit.prevent="handleSave"
					>
						<b-card
							class="mb-3"
							header-class="h5 mb-0"
							header-tag="h2"
							no-body
							tag="section"
						>
							<b-card-body>
								<b-form-group
									:invalid-feedback="item.errors.get('name')"
									:label="$t('Name')"
									:state="item.errors.has('name') ? false : null"
									label-for="name"
								>
									<b-form-input
										id="name"
										v-model="item.name"
										:readonly="$gate.deny('update', item)"
										:state="item.errors.has('name') ? false : null"
										autofocus
										name="name"
									/>
								</b-form-group>

								<b-form-group
									:invalid-feedback="item.errors.get('short_name')"
									:label="$t('Short name')"
									:state="item.errors.has('short_name') ? false : null"
									label-for="short_name"
								>
									<b-form-input
										id="short_name"
										v-model="item.short_name"
										:readonly="$gate.deny('update', item)"
										:state="item.errors.has('short_name') ? false : null"
										maxlength="5"
										name="short_name"
									/>
								</b-form-group>

								<b-form-group
									v-for="field in fieldsLookup"
									:key="field.name"
									:invalid-feedback="item.errors.get(field.name)"
									:label="field.label"
									:label-for="field.name"
									:state="item.errors.has(field.name) ? false : null"
								>
									<b-input-group>
										<b-form-input
											:id="field.name"
											v-model="item[field.name]"
											:name="field.name"
											:readonly="!!field.readonly"
											:state="item.errors.has(field.name) ? false : null"
											step="0.001"
											type="number"
										/>

										<b-input-group-text slot="append">
											<span v-html="field.append" />
										</b-input-group-text>
									</b-input-group>
								</b-form-group>

								<b-form-group
									:invalid-feedback="item.errors.get('foundation_id')"
									:label="$t('Foundation')"
									:state="item.errors.has('foundation_id') ? false : null"
									label-for="foundation"
								>
									<foundation-select
										v-if="$gate.allow('update', item) && $gate.allow('updateFoundation', item)"
										id="foundation"
										v-model="foundation"
										:resource="`projects/${projectId}/foundations?type=${item.type}`"
										:state="item.errors.has('foundation_id') ? false : null"
										name="foundation"
										@input="item.foundation_id = $event ? $event.id : null"
									/>
									<b-input v-else :value="foundation ? foundation.name : null" readonly />
								</b-form-group>
							</b-card-body>

							<b-card-footer v-if="$gate.allow('update', item)">
								<b-button :disabled="item.busy" type="submit" variant="primary">
									{{ $t('Save') }}

									<b-spinner v-if="item.busy" small />
									<fa v-else class="ml-1" icon="save" />
								</b-button>
							</b-card-footer>
						</b-card>
					</b-form>
				</b-tab>

				<b-tab
					v-if="$gate.allow('update', item)"
					:title="$t('Services')"
				>
					<wall-services
						:project-id="projectId"
						:wall-id="id"
						:wall-type="item.type"
					/>
				</b-tab>

				<b-tab :title="$t('Services to complete')">
					<wall-services-to-complete
						:project-id="projectId"
						:wall-id="id"
					/>
				</b-tab>

				<b-tab
					v-if="$gate.allow('update', item)"
					:title="$t('Elements')"
				>
					<wall-elements
						:project-id="projectId"
						:wall-id="id"
					/>
				</b-tab>

				<measurement :api-url="`${itemUrl}/d11e`" />
			</b-tabs>
		</article>
	</main>
</template>

<script>
import Form from 'vform';
import WallElements from '@/components/walls/WallElements';
import FoundationSelect from '@/components/selects/ResourceSelect';

import DuplicateModal from '@/components/DuplicateModal';
import WallServicesToComplete from "@/components/walls/WallServicesToComplete";
import WallServices from "@/components/walls/WallServices";
import ElementForm from "@/components/elements/ElementForm";
import ServicesCopy from "@/components/walls/ServicesCopy";
import WALLS_FIELDS_LOOKUP from "@/constants/walls_fields_lookup";
import Measurement from "@/components/Measurement";

import ProjectFoundationsCreateView from '@/components/project_foundations/CreateView'
import itemMixin from "@/mixins/itemMixin";
import ProjectElementsCreateView from "@/components/project_elements/CreateView";

export default {
	name: 'Wall',
	components: {
		ProjectElementsCreateView,
		ProjectFoundationsCreateView,
		Measurement,
		ServicesCopy,
		ElementForm,
		WallServices,
		WallServicesToComplete,
		DuplicateModal,
		WallElements,
		FoundationSelect
	},
	mixins: [itemMixin],
	props: {
		projectId: {
			type: [Number, String],
			required: true,
		},
		componentId: {
			type: [Number, String],
			required: true,
		},
		floorId: {
			type: [Number, String],
			required: true,
		},
		roomId: {
			type: [Number, String],
			required: true,
		},
	},
	data() {
		return {
			showNewElementModal: false,
			showNewFoundationModal: false,
			item: new Form({
				name: null,
				short_name: null,
				height: null,
				width: null,
				length: null,
				area: null,
				diameter: null,
				foundation_id: null,
				completed_foundation_services_count: 0,
				type: null,
				model_name: null
			}),
			foundation: null,
			elements: [],
			availableElements: [],
			services: [],
			tabIndex:0,
		};
	},
	computed: {
		baseUrl() {
			return `/api/projects/${this.projectId}/components/${this.componentId}/floors/${this.floorId}/rooms/${this.roomId}/walls`;
		},
		resourceName() {
			return 'walls';
		},
		area() {
			if (!this.item.area) {
				return null;
			}

			return this.item.area.toLocaleString(this.$i18n.locale, {maximumFractionDigits: 4})
		},
		fieldsLookup() {
			return WALLS_FIELDS_LOOKUP[this.item.type];
		},
	},
	mounted() {
		this.tabIndex = parseInt(this.$router.currentRoute.query.tabIndex || 0)
	},
	methods: {
		handleTabIndex(index){
			const url = new URL(window.location);
			url.searchParams.set('tabIndex', index);
			window.history.pushState({}, '', url);
		},
		afterDelete() {
			this.$router.push({
				name: 'projects.components.floors.rooms.show',
				params: {
					projectId: this.projectId,
					componentId: this.componentId,
					floorId: this.floorId,
					roomId: this.roomId,
				},
			});
		},

		handleDuplicated(data) {
			this.$root.$emit('created::walls', data);

			if (!(data && data.id)) {
				return;
			}

			this.$router.push({
				name: 'projects.components.floors.rooms.walls.show',
				params: {
					projectId: this.projectId,
					componentId: this.componentId,
					floorId: this.floorId,
					roomId: this.roomId,
					wallId: data.id,
				},
			});
		},
		incrementCompletedFoundationServicesCount() {
			this.item.completed_foundation_services_count++;
		},

		setData(data) {
			this.services = data.services;
			this.foundation = data.foundation;
			this.item.fill(data);
		},
	},
};
</script>
